"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconKitchen = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M20,2.01 L4,2 L4,22 L20,22 L20,2.01 Z M18,20 L6,20 L6,10.98 L18,10.98 L18,20 Z M18,9 L6,9 L6,4 L18,4 L18,9 Z M8,5 L10,5 L10,8 L8,8 L8,5 Z M8,12 L10,12 L10,17 L8,17 L8,12 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconKitchen')(IconKitchen);